<template>
  <section>
    <div
      class="report-timeline mt-5 relative"
      v-if="parseInt(versions.length) > 0"
    >
      <div
        v-for="(version, index) in filteredVersions"
        :key="version.id"
        class="intro-x relative flex items-center mb-3"
      >
        <div class="report-timeline__image">
          <div class="flex h-10 w-10">
            <div
              class="h-3 m-auto my-auto rounded-full w-3 z-10"
              :class="
                index == parseInt(versions.length) - 1
                  ? 'bg-theme-1'
                  : 'bg-gray-500'
              "
            ></div>
          </div>
        </div>
        <div class="box px-5 py-3 ml-4 flex-1 zoom-in cursor-default">
          <div class="flex items-center">
            <div>
              <div class="font-medium">
                Version {{ index + 2 }}
                <span v-if="index == parseInt(versions.length) - 1"
                  >ACTUAL</span
                >
              </div>
              <!-- <div class="text-xs text-gray-500">Usuario: {{version.user_name}} - {{version.user_email}}</div> -->
            </div>
            <div class="text-xs text-gray-500 ml-auto">
              {{ version.created_at }}
            </div>
          </div>
          <div class="flex items-center">
            <div class="accordion accordion-boxed w-full">
              <div class="accordion-item">
                <div
                  v-if="
                    open == index + 1 ||
                    (index == parseInt(versions.length) - 1 && open == null)
                  "
                  class="accordion-collapse collapse show"
                >
                  <div class="overflow-auto">
                    <form
                      @submit.prevent="updateTaskVersion(version)"
                      class="form-task"
                    >
                      <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
                        <input
                          type="hidden"
                          class="input w-full border mt-2 flex-1"
                          v-model="version.id"
                        />
                        <div class="col-span-6 sm:col-span-6">
                          <label>Nombre:</label>
                          <input
                            type="text"
                            class="input w-full border mt-2 flex-1"
                            v-model="version.name"
                            required
                            :disabled="![1].includes(usersession.role)"
                          />
                        </div>
                        <div class="col-span-3 sm:col-span-3">
                          <label>Fecha de entrega:</label>
                          <input
                            type="date"
                            class="input w-full border mt-2 flex-1"
                            v-model="version.date"
                            required
                            :disabled="usersession.role == 4"
                          />
                        </div>
                        <div
                          v-if="usersession.role == 4"
                          class="col-span-3 sm:col-span-3"
                        >
                          <label>Horas:</label>
                          <input
                            type="number"
                            class="input w-full border mt-2 flex-1"
                            v-model="version.hours"
                            required
                            disabled
                          />
                        </div>
                        <div v-else class="col-span-3 sm:col-span-3">
                          <label>Horas:</label>
                          <input
                            type="number"
                            class="input w-full border mt-2 flex-1"
                            min="0"
                            max="100"
                            step=".01"
                            v-model="version.hours"
                            required
                            :class="
                              version.state_id == 4 ? 'cursor-not-allowed' : ''
                            "
                            :disabled="version.state_id == 4"
                          />
                        </div>
                        <div class="col-span-12 sm:col-span-12 xxl:col-span-12">
                          <label>Descripcion</label>
                          <textarea
                            class="input w-full border mt-2"
                            rows="5"
                            v-model="version.description"
                            :disabled="![1].includes(usersession.role)"
                          ></textarea>
                        </div>
                        <div class="col-span-3 sm:col-span-3">
                          <label>Proyecto</label>
                          <input
                            type="text"
                            class="input w-full border mt-2 flex-1"
                            v-model="version.campaign_attribute.project_name"
                            required
                            disabled
                          />
                        </div>
                        <div class="col-span-3 sm:col-span-3">
                          <label>Campaña</label>
                          <input
                            type="text"
                            class="input w-full border mt-2 flex-1"
                            v-model="version.campaign_attribute.name"
                            required
                            disabled
                          />
                        </div>
                        <div
                          v-if="usersession.role == 4"
                          class="col-span-3 sm:col-span-3"
                        >
                          <label>Estado</label>
                          <select
                            class="input w-full border mt-2"
                            @change="changeStatus($event)"
                            :class="version.state_id == 4 ? 'bg-disabled' : ''"
                            :disabled="version.state_id == 4"
                            v-model="version.state_id"
                            required
                          >
                            <option disabled>Seleccione el estado...</option>
                            <option
                              v-for="state in filteredStates"
                              :value="state.id"
                            >
                              {{ state.name }}
                            </option>
                          </select>
                        </div>
                        <div v-else class="col-span-3 sm:col-span-3">
                          <label>Estado</label>
                          <select
                            class="input w-full border mt-2"
                            @change="changeStatus($event)"
                            :class="version.state_id == 4 ? 'bg-disabled' : ''"
                            :disabled="version.state_id == 4"
                            v-model="version.state_id"
                            required
                          >
                            <option disabled>Seleccione el estado...</option>
                            <option
                              v-for="state in states"
                              :value="state.id"
                              :disabled="
                                ![4].includes(state.id) &&
                                usersession.team_id != version.team_id
                              "
                            >
                              {{ state.name }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="col-span-3 sm:col-span-3"
                          v-if="usersession.team_id == team_session"
                        >
                          <label>Usuario</label>
                          <select
                            class="input w-full border mt-2 flex-1"
                            :class="version.state_id == 4 ? 'bg-disabled' : ''"
                            :disabled="version.state_id == 4"
                            v-model="version.user_id"
                            required
                          >
                            <option disabled>Seleccione el usuario</option>
                            \
                            <template v-for="user in filteredUsers">
                              <option
                                v-if="[2, 3, 4, 5].includes(user.roles[0].id)"
                                :key="user.id"
                                :value="user.id"
                              >
                                {{ user.name }}
                              </option>
                            </template>
                          </select>
                        </div>
                        <template v-if="version.path">
                          <div
                            class="relative col-span-6 sm:col-span-6"
                            v-for="(path, key) in version.path.split(',')"
                          >
                            <label>Url {{ key + 1 }}</label>
                            <input
                              type="text"
                              class="input w-full border mt-2 flex-1"
                              :value="path"
                              disabled
                            />
                            <div
                              class="absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
                              v-if="path"
                            >
                              <a :href="path" target="_blank">
                                <app-icon name="link" classname="w-4 h-4" />
                              </a>
                            </div>
                          </div>
                        </template>

                        <!-- ANSWER -->
                        <div
                          class="col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12 bg-gray-300 px-3 rounded"
                          v-if="[3, 4, 5, 6, 7].includes(version.state_id)"
                        >
                          <div class="col-span-6 sm:col-span-6">
                            <label>Descripcion Respuesta</label>
                            <textarea
                              class="input w-full border mt-2"
                              rows="3"
                              v-model="version.response_observations"
                              required
                              :disabled="
                                version.state_id == 6 ||
                                version.state_id == 4 ||
                                usersession.team_id != version.team_id
                              "
                            >
                            </textarea>
                          </div>

                          <template v-if="!edit_response_path">
                            <p class="relative col-span-12 sm:col-span-12">
                              Urls Respuesta
                              <a
                                v-on:click="editResponsePath()"
                                v-if="version.state_id != 4"
                                >- Editar</a
                              >
                            </p>
                            <div
                              class="relative col-span-6 sm:col-span-6"
                              v-for="(path, key) in version.response_path"
                            >
                              <label>Url Respuesta {{ key + 1 }}</label>
                              <input
                                type="text"
                                class="input w-full border mt-2 flex-1"
                                :value="path"
                              />
                              <div
                                class="absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
                                v-if="path"
                              >
                                <a :href="path" target="_blank">
                                  <app-icon name="link" classname="w-4 h-4" />
                                </a>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            <div class="relative col-span-6 sm:col-span-6">
                              <label>Url Archivo Respuesta (opcional)</label>
                              <MultiSelect
                                v-model="response_path"
                                :options="responsePathOptions"
                                :multiple="true"
                                :taggable="true"
                                @tag="addResponseTag($event, version)"
                                class="mt-2"
                                :disabled="
                                  version.state_id == 6 ||
                                  version.state_id == 4 ||
                                  usersession.team_id != version.team_id
                                "
                              />
                            </div>
                          </template>
                        </div>
                        <!-- END ANSWER -->
                      </div>
                      <div
                        class="px-5 py-3 text-right border-t border-gray-200"
                      >
                        <button
                          type="submit"
                          class="button bg-theme-1 text-white"
                          id="editversion"
                          :disabled="buttonIsLoading"
                        >
                          <template v-if="buttonIsLoading">
                            Cargando...
                          </template>
                          <template v-else> Modificar </template>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="my-4" />
          <div class="accordion-header cursor-pointer">
            <template v-if="open === null || open != index + 1">
              <button
                class="accordion-button w-full text-left focus:outline-none"
                type="button"
                @click="open = index + 1"
              >
                Ver
              </button>
            </template>
            <template
              v-else-if="
                open === index + 1 && index != parseInt(versions.length) - 1
              "
            >
              <button
                class="accordion-button w-full text-left focus:outline-none"
                type="button"
                @click="open = null"
              >
                Ocultar
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'

import Icon from '@/components/admin/partials/Icon'
import MultiSelect from '@/components/assets/MultiSelect/MultiSelect'

export default {
  props: ['users', 'states', 'usersession', 'task_current', 'team_session'],

  data() {
    return {
      current_version: {
        version: {},
        entity: 'taskversion',
      },
      versions: {},
      open: null,
      options: [],
      buttonIsLoading: false,
      responsePathOptions: [],
      responseVersionPathOptions: [],
      edit_response_path: false,
      response_path: [],
    }
  },
  mounted() {
    this.getListChildrenTasks()
  },
  methods: {
    async getListChildrenTasks() {
      if (!this.task_current || !this.task_current.id) {
        return
      }

      try {
        //console.log('task_current_id', this.task_current.id)
        await this.get(`task/children/${this.task_current.id}`).then((data) => {
          this.versions = data.model
        })
      } catch (error) {
        window.$toast.error(error)
      } finally {
      }
    },
    updateTaskVersion(item) {
      var vm = this
      this.buttonIsLoading = true
      window.$('#editversion').button('loading')
      vm.current_version.version = item
      vm.current_version.version.response_path =
        this.response_path.length > 0
          ? vm.response_path
          : vm.current_version.version.response_path
      console.log(vm.current_version)
      vm.store(vm.current_version)
        .then((item) => {
          window.$('#editversion').button('reset')
          this.buttonIsLoading = false
          window.location = window.location.href.split('?')[0]
        })
        .catch((message) => {
          window.$('#editversion').button('reset')
          this.buttonIsLoading = false
        })
    },
    addTag(newTag) {
      this.options.push(newTag)
      this.version.path.push(newTag)
    },
    addResponseTag(newTag, version) {
      this.responsePathOptions.push(newTag)
      if (this.response_path == null) {
        this.response_path = []
      }
      this.response_path.push(newTag)
    },
    editResponsePath() {
      this.edit_response_path = true
    },
    changeStatus(event) {
      var value = event.target.value

      if (value == 7) {
        this.edit_response_path = true
      }
    },
    ...mapActions(['get', 'store']),
  },
  computed: {
    filteredUsers() {
      return this.users.filter((item) => {
        var accounts_ids = item.accountsIds
        var search = accounts_ids.indexOf(
          this.task_current.campaign_attribute.project_account_id
        )

        if (this.usersession.role == 4) {
          return search !== -1
        } else {
          return search !== -1 && item.team_id == localStorage.session_team
        }
      })
    },
    filteredStates() {
      return this.states.filter((v) => {
        if (this.usersession.team_id != this.task_current.team_id) {
          return v.id == 4
        } else {
          return v.id != 4
        }
      })
    },
    filteredVersions() {
      return this.versions.map((v) => {
        if (v.response_path && !Array.isArray(v.response_path)) {
          v.response_path = v.response_path.split(',')
        }
        return v
      })
    },
  },
  components: {
    appIcon: Icon,
    MultiSelect,
  },
}
</script>



// WEBPACK FOOTER //
// TaskEditVersions.vue?08dbc64f